import React from "react";


const Modal3 = () => {


    return (

        <div className="container-fluid">
            <div className="modal fade" id="Modal3" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-center">
                            <div className="text-center w-100">
                                <h5 className="modal-title modaltitlesize" id="exampleModalLongTitle">Algorithmic Sorting Visualizer</h5>
                            </div>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="text-center p-3">
                            <img src="https://media.giphy.com/media/j32hdrc5bkTxJuAW5i/giphy.gif" className="img-fluid rounded" alt="Responsive image"></img>
                        </div>
                        <div className="modal-body promodaltextsize">
                            <div className="p-4">
                                <h3 className="text-center">Algorithmic Visualization and Comparison</h3>
                                <h4 className="text-center m-2">Language: Python</h4>
                                <h4 className="text-center m-2">Algorithm Selection | Data Manipulation
                                <br></br><br></br></h4>
                                <h4>Background<br></br><br></br></h4>
                                <p>
                                    A Sorting Algorithm is used to rearrange a given array of elements according to a comparison operator on the elements. The comparison operator is used to decide the new order of elements in the respective data structure.
                                </p>
                                <p>
                                    I wanted to incorporate some of the most commonly used sorting algorithms and selected six:
                                    <table class="table">
                                        <br></br><br></br>
                                        <tr>
                                            <td>Bubble Sort</td>
                                            <td>Merge Sort</td>
                                        </tr>
                                        <tr>
                                            <td>Insertion Sort</td>
                                            <td>Selection Sort</td>
                                        </tr>
                                        <tr>
                                            <td>Heap Sort</td>
                                            <td>Quick Sort</td>
                                        </tr>
                                    </table>
                                    <br></br>
                                </p>
                                <h4>Project Development<br></br><br></br></h4>
                                    <p>
                                        Many of the pre-existing projects I found were written in languages and frameworks such as Javascript and React, and the majority of them did not provide a comprehendable visual representation. I wanted to better understand how to work with algorithms while conceptualizing how to implement them into code, so I decided to write my own sorting visualization program utilizing various highly used sorting algorithms. 
                                    </p>
                                    <p>
                                        Although these algorithms are relatively basic in the world of algorithms, I was more concerned with the potential applications of this project beyond the scope of common sorting algorithms. This project allows for the user to select the value of "data bars" to be sorted, as well as the algorithm to be used. Doing so allows the user to compare some of the most heavily used sorting algorithms on small and large scales while easily comparing them statistically and visually. 
                                        <br></br><br></br> 
                                    </p>
                                    <h4>Reflection<br></br><br></br></h4>
                                    <p>
                                        This project was an interesting way to learn more about the implementation of heavily used algorithms while considering the effects of various data structures. Additionally, I had to oppurtunity to learn more about the Matplotlib module within Python, which was used to develop the animated visual. The keyword "yield" was a very important factor in making the program display the progression of the algorithms rather than just the final visual and statistical result. I am interested in the potential of Python and all that it can be used for in science and engineering, and I am eager to learn more about the manipulation and visualization of data structures and algorithms. 
                                    </p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button"
                            className="btn btn-outline-dark p-2 m-2 col-md-2" 
                            data-dismiss="modal">
                                Close
                            </button>
                                <a href="https://github.com/scottvcaputo/Algorithmic-Sorting-Visualizer"
                                target="_blank"
                                rel="noopener noreferrer"
                                type="button" 
                                className="btn btn-outline-secondary p-2 m-2 col-md-2">
                                    <i className="fab fa-github" /> Source
                                </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modal3;
